export default __webpack_public_path__ + "static/media/9783986100018.43241ff1.webp";